/**
 * PLAN — el mapa de las 12 semanas.
 *
 * Orientación, no acción: desde aquí no se inicia ninguna sesión. Consume el
 * curriculum directamente, así que ya está completa en lo esencial.
 */

import { useLiveQuery } from 'dexie-react-hooks';

import { CURRICULUM_ACTUAL } from '../../curriculum';
import { BLOQUES_ENFASIS, bloqueDeSemana } from '../../curriculum/v1/enfasis';
import { NOMBRE_AREA } from '../../domain/modelo/areas';
import { CLAVES_DIA_ORDENADAS, semanaActual } from '../../domain/reglas/progresion';
import { sesionesRepo } from '../../persistencia/sesionesRepo';
import { Pantalla } from '../comunes/Pantalla';
import { Suave, Tarjeta } from '../comunes/Tarjeta';
import estilos from './Plan.module.css';

export function Plan() {
  const sesiones = useLiveQuery(() => sesionesRepo.listar(), [], undefined);
  const semana = sesiones ? semanaActual(sesiones) : 1;
  const bloqueActual = bloqueDeSemana(semana);

  return (
    <Pantalla titulo="Plan" tituloVisible>
      <Suave>
        Los días son sesiones secuenciales, no días del calendario. Si perdés uno,
        simplemente seguís por la siguiente sesión pendiente.
      </Suave>

      <Tarjeta titulo="El ciclo de 7 sesiones">
        <ul className={estilos.dias}>
          {CLAVES_DIA_ORDENADAS.map((clave, indice) => {
            const sesion = CURRICULUM_ACTUAL.sesiones[clave];
            return (
              <li key={clave} className={estilos.dia}>
                <div className={estilos.diaCabecera}>
                  <span className={estilos.numero}>Día {indice + 1}</span>
                  <strong>{sesion.corto}</strong>
                </div>
                <p className={estilos.objetivo}>{sesion.objetivo}</p>
                <details>
                  <summary>Por qué está en el plan</summary>
                  <p>{sesion.porQue}</p>
                </details>
              </li>
            );
          })}
        </ul>
      </Tarjeta>

      <Tarjeta titulo="Antes y durante: baseline y checkpoints">
        <p className={estilos.objetivo}>{CURRICULUM_ACTUAL.sesiones.baseline.objetivo}</p>
        <Suave>
          Los checkpoints de las semanas 4, 8 y 12 usan tareas nuevas comparables. Nunca
          repiten las respuestas del baseline: si las repitieran, medirían memoria.
        </Suave>
      </Tarjeta>

      <Tarjeta titulo="Énfasis de las 12 semanas">
        <Suave>
          Todos los componentes están desde la semana 1. Lo único que cambia es el
          énfasis, y los bloques no son compartimentos rígidos.
        </Suave>
        <ul className={estilos.bloques}>
          {BLOQUES_ENFASIS.map((bloque) => {
            const esActual = bloque === bloqueActual;
            return (
              <li
                key={bloque.desdeSemana}
                className={esActual ? `${estilos.bloque} ${estilos.bloqueActual}` : estilos.bloque}
              >
                <div className={estilos.bloqueCabecera}>
                  <span className={estilos.numero}>
                    Semanas {bloque.desdeSemana}–{bloque.hastaSemana}
                  </span>
                  {esActual ? <span className={estilos.insignia}>Estás acá</span> : null}
                </div>
                <strong>{bloque.titulo}</strong>
                <p className={estilos.objetivo}>{bloque.descripcion}</p>
                <p className={estilos.areas}>
                  {bloque.areas.map((area) => NOMBRE_AREA[area]).join(' · ')}
                </p>
              </li>
            );
          })}
        </ul>
      </Tarjeta>
    </Pantalla>
  );
}
